import { NewFilterOption } from '@/components/FilterNew/types';
import useStatuses from '@/modules/tasks/views/TaskStasusesManager/hooks/useStatuses';
import getTaskStatusIcon from '@/modules/tasks/views/TaskStasusesManager/utils/getStatusIcon';

type Params = NonNullable<ReturnType<typeof useStatuses>['statuses']>[0];

export const getTaskStatusFilterOption = (status: Params): NewFilterOption => {
  return {
    value: status.id,
    label: status.name,
    Icon: () => getTaskStatusIcon({ size: 18, ...status }),
    item: status,
  };
};
